import type { Levers } from './LeverPanel'

/** Serialize the scenario levers for persistence (`Scenario.LeversJson`). */
export function serializeLevers(levers: Levers): string {
  return JSON.stringify(levers)
}

/**
 * Parse a persisted `leversJson` back into a `Levers`, defensively. A malformed/partial payload
 * must never crash the scenario page, so:
 *  - a parse failure, a non-object, or the legacy empty `{}` scaffold stub (no `capacity` and no
 *    `assumptions`) falls back to `defaults`;
 *  - otherwise each field is taken from the payload when present, else from `defaults`, and
 *    `advanced` is coerced to `null` when absent.
 */
export function parseLevers(json: string, defaults: Levers): Levers {
  let parsed: Partial<Levers> | null
  try {
    parsed = JSON.parse(json) as Partial<Levers>
  } catch {
    return defaults
  }
  if (!parsed || typeof parsed !== 'object') return defaults
  // Legacy scaffold stub ('{}') carried neither capacity nor assumptions — treat as "no levers saved".
  if (parsed.capacity == null && parsed.assumptions == null) return defaults
  return {
    capacity: parsed.capacity ?? defaults.capacity,
    targeting: parsed.targeting ?? defaults.targeting,
    assumptions: parsed.assumptions ?? defaults.assumptions,
    advanced: parsed.advanced ?? null,
  }
}
